import React from "react";

export const BrandMark = ({ size = 40, showWord = false }) => (
  <div className="flex items-center gap-3">
    <img
      src="/brand/logo.jpeg"
      alt="Plenty Rydez"
      width={size}
      height={size}
      style={{ width: size, height: size }}
      className="rounded-xl object-cover shadow-[0_0_18px_rgba(201,204,210,0.30)] ring-1 ring-platinum/30"
    />
    {showWord && (
      <div className="leading-none">
        <div className="font-serif text-lg text-white">Plenty Rydez</div>
        <div className="label-caps text-platinum/80 mt-0.5">NY · NJ · PA · DMV · CT</div>
      </div>
    )}
  </div>
);
